import { Footer as FBFooter } from "flowbite-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="hidden lg:block">
        <FBFooter container className="bg-gray-100 rounded-none">
          <FBFooter.Copyright
            by="Price Brothers Equipment Company"
            year={currentYear}
            className="hidden lg:block"
          />
          {/* Disclaimer */}
          <p className="text-center text-xs text-gray-500 mt-2 lg:mt-0 px-4">
            Prices and availability subject to change without notice.
          </p>
          <FBFooter.LinkGroup className="flex justify-center lg:justify-between">
            <FBFooter.Link href="/about">About</FBFooter.Link>
            <FBFooter.Link href="/contact">Contact</FBFooter.Link>
          </FBFooter.LinkGroup>
        </FBFooter>
      </div>
    </>
  );
}
